import { forwardRef, type SelectHTMLAttributes } from 'react'
import { ChevronDown } from 'lucide-react'
import { cn } from './cn'

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  invalid?: boolean
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { invalid, className, children, ...rest },
  ref,
) {
  return (
    <div className="relative w-full">
      <select
        ref={ref}
        className={cn(
          'w-full h-11 rounded-xl bg-surface text-ink',
          'border border-line focus:border-brand focus:outline-none',
          'focus:ring-2 focus:ring-brand/30 transition-all duration-150',
          'disabled:opacity-50 disabled:cursor-not-allowed',
          'pl-4 pr-10 appearance-none cursor-pointer',
          invalid && 'border-error focus:border-error focus:ring-error/30',
          className,
        )}
        {...rest}
      >
        {children}
      </select>
      <ChevronDown
        size={16}
        className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-ink-subtle"
      />
    </div>
  )
})
